<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M7.999999940395355,16C9.099999940395355,16,9.999999940395355,15.1,9.999999940395355,14C9.999999940395355,14,5.999999940395355,14,5.999999940395355,14C5.999999940395355,15.1,6.899999940395356,16,7.999999940395355,16C7.999999940395355,16,7.999999940395355,16,7.999999940395355,16ZM13.999999940395355,11C13.449999940395355,11,12.999999940395355,10.55,12.999999940395355,10C12.999999940395355,10,12.999999940395355,6,12.999999940395355,6C12.999999940395355,3.57,11.269999940395355,1.55,8.979999940395356,1.1C8.979999940395356,1.06,8.999999940395355,1.04,8.999999940395355,1C8.999999940395355,0.45,8.549999940395356,0,7.999999940395355,0C7.449999940395355,0,6.999999940395355,0.45,6.999999940395355,1C6.999999940395355,1.04,7.019999940395355,1.06,7.019999940395355,1.1C4.729999940395356,1.55,2.9999999403953552,3.57,2.9999999403953552,6C2.9999999403953552,6,2.9999999403953552,10,2.9999999403953552,10C2.9999999403953552,10.55,2.549999940395355,11,1.9999999403953552,11C1.4499999403953552,11,0.9999999403953552,11.45,0.9999999403953552,12C0.9999999403953552,12.55,1.4499999403953552,13,1.9999999403953552,13C1.9999999403953552,13,13.999999940395355,13,13.999999940395355,13C14.549999940395356,13,14.999999940395355,12.55,14.999999940395355,12C14.999999940395355,11.45,14.549999940395356,11,13.999999940395355,11C13.999999940395355,11,13.999999940395355,11,13.999999940395355,11Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Notifications',
} as DefineComponent
</script>
